import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import "./LikeButton.css";
const LikeButton = ({ postId }) => {
  const [likeCount, setLikeCount] = useState(0);
  const [userLiked, setUserLiked] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    axiosInstance
      .get(`/posts/${postId}/likes`, token ? {
        headers: { Authorization: `Bearer ${token}` },
      } : {})
      .then((res) => {
        setLikeCount(res.data.likeCount);
        setUserLiked(res.data.userLiked || false);
      })
      .catch((err) => console.error("Error fetching likes:", err));
  }, [postId, token]);

  const toggleLike = async () => {
    if (!token) return alert("Please log in to like posts!");

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const url = `/posts/${postId}/${userLiked ? "unlike" : "like"}`;

    try {
      if (userLiked) {
        await axiosInstance.delete(url, config);
      } else {
        await axiosInstance.post(url, {}, config);
      }

      setLikeCount((prev) => prev + (userLiked ? -1 : 1));
      setUserLiked(!userLiked);
    } catch (err) {
      console.error("Error toggling like:", err);
    }
  };

  return token ? (
    <button onClick={toggleLike} className="likeButton" style={{ marginTop: "0.5rem" }}>
      {userLiked ? "💔 Unlike" : "❤️ Like"} ({likeCount})
    </button>
  ) : (
    <span className="likeCountOnly">
      ❤️ {likeCount}
    </span>
  );
};

export default LikeButton;
